import {
  Box,
  Button,
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useMultiStyleConfig,
  useTab
} from '@chakra-ui/react';
import parser from 'html-react-parser';
import React, { useState } from 'react';

// const TimeZones = {
//   in: {
//     locale: 'en-GB',
//     timeZone: 'Asia/Kolkata',
//   },
//   us: {
//     locale: 'en-CA',
//     timeZone: 'Canada/Central',
//   },
//   uk: {
//     locale: 'en-GB',
//     timeZone: 'Europe/London',
//   },
//   au: {
//     locale: 'en-AU',
//     timeZone: 'Australia/Sydney',
//   },
//   sg: {
//     locale: 'en-SG',
//     timeZone: 'Asia/Singapore',
//   },
//   ca: {
//     locale: 'en-CA',
//     timeZone: 'Canada/Central',
//   },
//   my: {
//     locale: 'ms-MY',
//     timeZone: 'Asia/Kuala_Lumpur',
//   },
//   global: {
//     locale: 'en-GB',
//     timeZone: 'Europe/London',
//   },
// };

// const usrlocaltimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
// const usrlocaltzname = moment.tz(usrlocaltimezone).format('z');

const ProSchedTabCont = ({ config, table, table_1, region }) => {
  const [tableData, setTableData] = useState([...table]);
  // const [table1Data, setTable1Data] = useState([...table_1]);
  const [deferHours, setDeferHours] = useState(0);
  const [deferMins, setDeferMins] = useState(0);

  // consoleLog('table1Data', table1Data);

  if (config[region]) {
    config[region].slots = Object.keys(config[region]?.slots)
      .sort()
      .reduce((obj, key) => {
        obj[key] = config[region].slots[key];
        return obj;
      }, {});
  }

  const renderTZTabs = () => {
    // consoleLog('renderTZTabs');
    return (
      config[region] &&
      config[region].slots &&
      Object.keys(config[region].slots)
        .sort((el_a, el_b) => parseInt(el_a) - parseInt(el_b))
        .map((el, i) => {
          return (
            <Tab
              _selected={{
                color: '#CF4520',
                bg: 'transparent',
                border: '0',
                borderBottom: '4px solid #CF4520',
                borderRadius: '0',
              }}
              background="#F0F0F0"
              mr={{
                base: '10px',
                md: '30px',
              }}
              ml={{
                base: '3px',
                md: i === 0 ? '0' : '6px',
              }}
              borderRadius="0 15px 0 15px"
              onClick={() => updateTimes(el)}
              _focus={{
                outline: 'focus',
              }}
              fontSize={{
                base: '12px',
                md: '18px',
              }}
              pl={{
                base: '3px',
                md: '16px',
              }}
              pr={{
                base: '3px',
                md: '16px',
              }}
              flex="1"
              whiteSpace="normal"
              wordBreak="break-word"
              fontWeight={'bold'}
              minW={{ base: '74px', md: '122px' }}
              minH={{ base: '47px', md: '65px' }}
            >
              {config.in.slots[el]}
            </Tab>
          );
        })
    );
  };

  const updateTimes = el => {
    // consoleLog('updateTimes');
    const time = el.split('.');
    setDeferHours(time[0]);
    setDeferMins(time[1] === '5' ? '30' : '');
  };

  const getDeferredTime = (date, deferredHours, deferredMins) => {
    // const { locale, timeZone } = TimeZones[region];
    let prgDate = new Date(date);
    prgDate = prgDate.toLocaleString('en-US');

    prgDate = new Date(prgDate);
    if (deferredHours) {
      prgDate.setHours(prgDate.getHours() + parseInt(deferredHours));
    }
    if (deferredMins) {
      prgDate.setMinutes(prgDate.getMinutes() + parseInt(deferredMins));
    }
    return prgDate;
  };

  const renderTable = (days, deferred, tableObj) => {
    // consoleLog('tableObj', tableObj);
    return (
      <Flex flexDirection="column" w="100%" mt={{ base: '20px', md: '50px' }}>
        <Box>
          <Flex mb="20px">
            {tableObj?.map((el, i) => {
              return (
                <Box
                  display={'flex'}
                  alignItems="center"
                  // justifyContent="center"
                  key={i}
                  w="42%"
                  fontSize={{ base: '14px', md: '18px' }}
                  m="0 0 0 0"
                  pl={{ md: '15%', base: '0' }}
                  fontWeight="bold"
                  color={{ base: '#969696', md: '#040404' }}
                  textAlign={{ base: 'left', md: 'center' }}
                  _first={{
                    textAlign: 'left',
                    w: '16%',
                    m: '0 0 0 0',
                    p: { base: '0 5px', md: '0 0  0 50px' }
                  }}
                >
                  {el.Title}
                </Box>
              );
            })}
          </Flex>
        </Box>
        <Box>
          <Flex mb="20px">
            {tableObj?.map((el, i) => {
              return (
                <Box
                  w="42%"
                  key={i}
                  m="0 0 0 0"
                  textAlign="center"
                  fontSize="14px"
                  _first={{
                    textAlign: 'left',
                    w: '15%',
                    m: '0 0 0 0',
                  }}
                >
                  {renderTableData(el, i, days, deferred, tableObj)}
                </Box>
              );
            })}
          </Flex>
        </Box>
      </Flex>
    );
  };

  const renderTableData = (el, index, days, deferred, tableObj) => {
    return Object.keys(el).map((obj, j) => {
      let startTime = getDeferredTime(
        tableObj[index][obj].StartTime,
        deferHours,
        deferMins
      );
      let endTime = getDeferredTime(
        tableObj[index][obj].EndTime,
        deferHours,
        deferMins
      );
      let month = startTime.toLocaleString('default', {
        month: 'short',
      });
      let day = startTime.toLocaleString('default', {
        day: 'numeric',
      });
      startTime =
        startTime.toString() !== 'Invalid Date'
          ? `${startTime.toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            })} - `
          : '';
      endTime =
        endTime.toString() !== 'Invalid Date'
          ? endTime.toLocaleTimeString([], {
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            })
          : '';

      const text = tableObj[index][obj].text
        ? parser(tableObj[index][obj].text)
        : '';
      return (
        <Flex
          flexDirection="column"
          textAlign="center"
          padding={{ md: '0 0 0 50px', base: '0 5px' }}
          fontSize={{ base: '12px', lg: 'inherit' }}
          _even={{
            bg: '#F9F9F9',
          }}
          key={j}
        >
          {index === 0 && days >= j && obj !== 'Title' && (
            <Box
              color="#040404"
              fontWeight="bold"
              p="5px 0px 5px 0px"
              key={j}
              border="0"
              whiteSpace="nowrap"
              display="flex"
              fontSize={{ base: '13px', md: '18px' }}
              justifyContent="Left"
              alignItems="center"
              m="0 28px"
              minH={{ base: '90px', md: '82px' }}
              _first={{
                textAlign: 'left',
                m: '0',
              }}
            >
              {tableObj[index][obj]}
            </Box>
          )}
          {index > 0 && days >= j && obj !== 'Title' && (
            <>
              <Box
                as="span"
                p="5px 0px 5px 0px"
                key={j}
                border="0"
                display="flex"
                fontSize={{ base: '14px', md: '18px' }}
                // justifyContent="center"
                alignItems="center"
                flexWrap="wrap"
                textAlign={{ base: 'left', md: 'center' }}
                minH={{ base: '90px', md: '82px' }}
              >
                <Box
                  as="span"
                  display={{ md: 'inline-flex', base: 'block' }}
                  width={{ md: 'auto', base: '100%' }}
                >
                  {month.toString() !== 'Invalid Date' &&
                  day.toString() !== 'Invalid Date'
                    ? `${month} ${day}`
                    : ''}
                  &nbsp;
                </Box>
                <Box
                  textAlign={{ base: 'left', md: 'center' }}
                  w={{ base: '100%', md: 'auto' }}
                >
                  <Box
                    as="span"
                    color="#CF4520"
                    display={startTime ? 'inline' : 'none'}
                    pl={{ md: '5px', base: '0' }}
                  >
                    {startTime}
                  </Box>
                  <Box
                    as="span"
                    color="#CF4520"
                    display={startTime ? 'inline' : 'none'}
                  >
                    &nbsp;{endTime}&nbsp;
                    {/* <Box as="span" pl="5px"> */}
                    {/* {config[region].timezone} */}
                    {/* {usrlocaltzname != '+08' ? usrlocaltzname : 'SGT'}
                  </Box> */}
                  </Box>
                </Box>
                <Box
                  as="span"
                  textAlign={'left'}
                  w={{ base: '100%', md: 'auto' }}
                >
                  {text}
                </Box>
              </Box>
            </>
          )}
        </Flex>
      );
    });
  };
  
  const CustomTab = React.forwardRef((props, ref) => {
    // 1. Reuse the `useTab` hook
    const tabProps = useTab({ ...props, ref });
    const isSelected = !!tabProps['aria-selected'];

    // 2. Hook into the Tabs `size`, `variant`, props
    const styles = useMultiStyleConfig('Tabs', tabProps);
    const Arrow = () => {
      return (
        <Box
          as="span"
          position="absolute"
          width={{ base: "10px", md: "20px" }}
          display={isSelected ? 'block' : 'none'}
          height={{ base: "6px", md: "11px" }}
          clipPath="polygon(0 0, 50% 100%, 100% 0)"
          left="50%"
          bottom={{ base: "-4px", md: "-10px" }}
          background="#CF4520"
          // animation={spinAnimation}
          style={{ transition: 'width 1s' }}
          // transform="rotate(45deg)"
          zIndex="0"
          transition="0.4s linear"
        ></Box>
      );
    };

    return (
      <Button
        __css={styles.tab}
        {...tabProps}
        width="50%"
        color={isSelected ? '#FFFFFF !important' : '#979797  !important'}
        bg={isSelected ? '#CF4520' : '#ECECEC'}
        border="0"
        fontFamily="FedraSansStd-book"
        fontStyle="normal"
        fontWeight="600"
        fontSize={{ base: '14px', sm: '22.8514px' }}
        lineHeight="150.3%"
        _active={{ bg: '#CF4520', border: '0' }}
        _focus={{ bg: '#CF4520', border: '0' }}
        pos="relative"
        height={{ base: '45px', sm: '81px' }}
        p={{ base: '0', sm: '1rem' }}
      >
        {/* <Box as="span" mr="2" color={isSelected ? '#FFFFFF' : '#979797'}> */}
        {isSelected ? <Arrow /> : ''}
        {/* </Box> */}
        {tabProps.children}
      </Button>
    );
  });
  
  return (
    <Box w="100%" m="0 auto">
      <Tabs
        isFitted
        variant="enclosed"
        p="0"
        className="tabcontent"
        border="2px solid #F0F0F0"
        borderRadius="12px"
        paddingBottom={{ base: "0", md: "20px" }}
      >
        <TabList borderBottom="none">
          <CustomTab style={{ borderRadius: '10px 0 0 0' }}>
            {/* <span style={{fontWeight:"bold",paddingBottom:"10px"}}> */}
            {config.tab1}
            {/* </span> */}
          </CustomTab>
          {/* <Tab
            bg="#ececec"
            borderRadius="0.8rem 0 0 0"
            // borderLeftRadius="0"
            // borderTopRightRadius="0"
            // borderBottomRightRadius="0.8rem"
            // borderBottomLeftRadius="0.8rem"
            _selected={{
              color: '#cf4520',
              bg: 'transparent',
            }}
            _focus={{
              outline: 'focus',
            }}
            w="50%"
          >
            <Text as="span" fontWeight="bold" pb="10px">
              {config.tab1}
            </Text>
          </Tab> */}
          {/* <Tab
            bg="#ececec"
            borderRadius="0 0.8rem 0 0"
            _selected={{
              color: '#cf4520',
              bg: 'transparent',
            }}
            _focus={{
              outline: 'focus',
            }}
          >
            <Text as="span" fontWeight="bold" pb="10px">
              {config.tab2}
            </Text> */}
          {/* </Tab> */}
          <CustomTab style={{ borderRadius: '0 10px 0 0' }}>
            {/* <Text as="span" fontWeight="bold" pb="10px"> */}
            {config.tab2}
            {/* </Text> */}
          </CustomTab>
        </TabList>
        <Tabs
          variant="rounded"
          m={{ base: "28px auto 0 auto", md: "60px auto 0 auto" }}
          maxW="850px"
          overflowX={{ base: 'auto', md: 'auto' }}
        >
          <TabList>{renderTZTabs()}</TabList>
        </Tabs>
        <TabPanels m={{ base: "15px auto 0 auto", md: "70px auto 0 auto" }} maxW="900px">
          <TabPanel p={{ base: '0', md: 'auto' }}>
            {renderTable('5', null, tableData)}
          </TabPanel>
          <TabPanel p={{ base: '0', md: 'auto' }}>
            {renderTable('2', null, table_1)}
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default ProSchedTabCont;
